import { render, staticRenderFns } from "./answerDetailPerson.vue?vue&type=template&id=2a319ada&scoped=true&"
import script from "./answerDetailPerson.vue?vue&type=script&lang=js&"
export * from "./answerDetailPerson.vue?vue&type=script&lang=js&"
import style0 from "./answerDetailPerson.vue?vue&type=style&index=0&id=2a319ada&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a319ada",
  null
  
)

export default component.exports